import React from 'react';
import PropTypes from 'prop-types';
import { Route, IndexRedirect } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import App from './app';
import Deductions from './deductions/deductions';
import JobSelectorPage from './deductions/selectJob';
import ReportPage from './deductions/report';
import JobsPage from './deductions/jobs';
import LookupAnimationPage from './deductions/lookupAnimation';
import TaxLandingContainer from './taxLandingContainer';
import HRBLandingContainer from './hrbLandingContainer';
import BenefitsApp from './benefits/app';
import BenefitsSelectionPage from './benefits/selectionPage';
import PayoffPageContainer from './benefits/payoffPageContainer';

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
  };
}

const jobsPath =
  ':jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs(/:jobs)))))))))))';

const navProps = {
  children: PropTypes.element.isRequired,
};

const StrideHeaderWithNav = props => (
  <StrideHeaderWrapper
    showPhone={false}
    navItems={['about', 'health', 'vision', 'life', 'dental', 'account']}>
    {props.children}
  </StrideHeaderWrapper>
);
StrideHeaderWithNav.propTypes = navProps;

const StrideHeaderEmpty = props => (
  <StrideHeaderWrapper showPhone={false}>{props.children}</StrideHeaderWrapper>
);
StrideHeaderEmpty.propTypes = navProps;

export default (
  <Route component={App}>
    <Route component={TranslationProvider} keys={['app', 'common', 'taxes']}>
      <Route component={StrideHeaderWithNav}>
        <Route path="/" component={TaxLandingContainer} onEnter={bindPageViewTracking()} />
      </Route>

      <Route component={StrideHeaderWithNav}>
        <Route path="hrblock" component={HRBLandingContainer} onEnter={bindPageViewTracking()} />
      </Route>

      <Route component={StrideHeaderEmpty}>
        <Route component={Deductions} path="deductions">
          <IndexRedirect to="/deductions/select-job" />
          <Route path="jobs" component={JobsPage} onEnter={bindPageViewTracking()} />
          <Route path="select-job" component={JobSelectorPage} onEnter={bindPageViewTracking()} />
          <Route path={`lookup/${jobsPath}`} component={LookupAnimationPage} />
          <Route path={jobsPath} component={ReportPage} onEnter={bindPageViewTracking()} />
        </Route>
      </Route>

      <Route component={BenefitsApp}>
        <Route path="rewards" component={BenefitsSelectionPage} onEnter={bindPageViewTracking()} />
        <Route path="rewards/my" component={PayoffPageContainer} onEnter={bindPageViewTracking()} />
      </Route>
    </Route>
  </Route>
);
